export const EMPTY_PRINTERS = {
  barcode_labels_printers: '',
  check_printers: '',
  standard_printers: '',
  windshield_label_printers: '',
}
